import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '../ui';

import { dictionaryItem } from '../../hocs/withDictionary';
import { formatPriceWithCurrency } from '../../lib/format';

const PitchPricing = ({
  numberOfNights,
  totalPrice,
  minPricePerNight,
  pitchId,
}) => {
  // If the user has selected dates, then we show the cost for the entire stay
  if (numberOfNights > 0 && !!totalPrice) {
    return (
      <div>
        <span data-testid={`pitch-pricing-total-price/${pitchId}`}>
          <b>{formatPriceWithCurrency(totalPrice)} </b>
        </span>
        <Text
          span
          dictionary={dictionaryItem('AvailabilityPitches', 'PerStay')}
        />
      </div>
    );
  }
  // And if they haven't selected dates then we show the price per night
  return (
    <div>
      <Text span dictionary={dictionaryItem('AvailabilityPitches', 'From')} />
      <span data-testid={`pitch-pricing-nightly-price/${pitchId}`}>
        <b> {formatPriceWithCurrency(minPricePerNight)}</b>
      </span>
    </div>
  );
};

PitchPricing.propTypes = {
  numberOfNights: PropTypes.number,
  totalPrice: PropTypes.number,
  minPricePerNight: PropTypes.number,
  pitchId: PropTypes.string.isRequired,
};

PitchPricing.defaultProps = {
  numberOfNights: 0,
  totalPrice: 0,
  minPricePerNight: 0,
};

export default PitchPricing;
